import { render } from "./CornerstoneTest.vue?vue&type=template&id=14571dd9&scoped=true"
import script from "./CornerstoneTest.js?vue&type=script&lang=js&external"
export * from "./CornerstoneTest.js?vue&type=script&lang=js&external"

import "./CornerstoneTest.vue?vue&type=style&index=0&id=14571dd9&lang=css"
import "./CornerstoneTest.vue?vue&type=style&index=1&id=14571dd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14571dd9"]])

export default __exports__